import React from 'react'
import { Widget } from 'features/types'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import PreSearchDataGuards from './guards/PreSearchDataGuards'
import PostSearchDataGuards from './guards/PostSearchDataGuards'
import RunSearchEffect from './RunSearchEffect'
import FoamTree from './FoamTree'
import BelowThresholdGuard from './guards/BelowThresholdGuard'

const AudienceUsageAndAttitudeWidget: Widget = ({ widgetId }) => (
  <UnexpectedErrorBoundary>
    <PreSearchDataGuards widgetId={widgetId}>
      <RunSearchEffect widgetId={widgetId}>
        <PostSearchDataGuards widgetId={widgetId}>
          <BelowThresholdGuard widgetId={widgetId}>
            <FoamTree widgetId={widgetId} />
          </BelowThresholdGuard>
        </PostSearchDataGuards>
      </RunSearchEffect>
    </PreSearchDataGuards>
  </UnexpectedErrorBoundary>
)

export default AudienceUsageAndAttitudeWidget
